export default __webpack_public_path__ + "static/media/2000.207e9f45.png";